// src/api/http.js
class Http {
    constructor(headers = {}) {
      this.defaultHeaders = {
        'Content-Type': 'application/json',      
        ...headers
      };
    }
    
    async request(endpoint, config = {}) {
      const url = `${window.globalConfig.VITE_WCIP_API_URL}${endpoint}`;
      const headers = {
        ...this.defaultHeaders,
        ...config.headers,
      };
      console.log(headers, 'headers')
      const response = await fetch(url, {
        ...config,
        headers
      });
  
      if (!response.ok) {
        const error = await this.parseError(response);
        throw error;
      }
  
      return this.parseResponse(response);
    }
  
    async parseResponse(response) {
      const contentType = response.headers.get('Content-Type');
      if (contentType?.includes('application/json')) {
        return response.json();
      }
      return response.text();
    }
  
    async parseError(response) {
      try {
        const errorData = await response.json();
        return new Error(errorData.message || `HTTP error! status: ${response.status}`);
      } catch (e) {
        console.log(e.message)
        return new Error(`HTTP error! status: ${response.status}`);
      }
    }
  
    get(endpoint, config = {}) {
      return this.request(endpoint, {
        ...config,
        method: 'GET'
      });
    }
  
    post(endpoint, body, config = {}) {
      return this.request(endpoint, {
        ...config,
        method: 'POST',
        body: JSON.stringify(body)
      });
    }
  
    put(endpoint, body, config = {}) {
      return this.request(endpoint, {
        ...config,
        method: 'PUT',
        body: JSON.stringify(body)
      });
    }
  
    delete(endpoint, config = {}) {
      return this.request(endpoint, {
        ...config,
        method: 'DELETE'
      });
    }
  
    patch(endpoint, body, config = {}) {
      return this.request(endpoint, {
        ...config,
        method: 'PATCH',
        body: JSON.stringify(body)
      });
    }
  }
  
  // 创建全局实例
  const http = new Http();
    // const http = new Http(`/api`);
  export default http;